import { Dispatch, SetStateAction } from 'react';

export enum MENU_OPTIONS {
  RESOURCES = 'RESOURCES',
}

export interface BaseMainMenuTypes {
  itemOpen: MENU_OPTIONS | null;
  toggleItem: (key: MENU_OPTIONS) => void;
  items: any[];
  showCallButton?: boolean;
  isMobileOpen: boolean;
  setOpenContactDialog: Dispatch<SetStateAction<boolean>>;
  openTrialForm?: () => void;
}
